import React from "react";
import "./Building.css";
import { BoxProvider } from "../../Context/BoxContext"; // Import BoxProvider
import BoxWithContent from "../../Components/BoxWithContent"; // Import BoxWithContent component
import { useHrStyles } from "../../Context/HRContext";

export default function Building() {
  const hrStyles = useHrStyles();

  // First Box Content
  const heading = "Residential";
  const description =
    "Transforming houses into homes with personalized designs and flawless execution. From concept to completion, we bring your dream living space to life.";
  const image = "/assets/images/building1.jpg";
  const gradientColor = "#DBF1FD"; // Customize gradient color for first box
  const buttonVariant = "outline-success";
  const link1 = "/residential"; // Link for the first box

  // Second Box Content
  const heading2 = "Commercial";
  const description2 =
    "Shaping innovative and functional commercial spaces tailored to meet your business needs. Let us build the foundation for your success";
  const image2 = "/assets/images/building2.jpg"; // Image for the second box
  const gradientColor2 = "#DBF1FD"; // Customize gradient color for second box
  const buttonVariant2 = "outline-success";
  const link2 = "/commercial"; // Link for the second box

  return (
    <BoxProvider
      heading={heading}
      description={description}
      image={image}
      gradientColor={gradientColor}
      buttonVariant={buttonVariant}
      link1={link1} // Pass link1 to BoxProvider
      heading2={heading2}
      description2={description2}
      image2={image2}
      gradientColor2={gradientColor2}
      buttonVariant2={buttonVariant2}
      link2={link2} // Pass link2 to BoxProvider
    >
      <p className="building-text">
        Building Solutions For <br /> Every Space
      </p>
      <hr style={hrStyles} />
      <p className="building-description">
        At BEAMS, we specialize in crafting exceptional residential and
        commercial spaces. Our expertise lies in turning architectural visions
        into tangible realities, ensuring quality and excellence in every
        project.
      </p>
      <BoxWithContent /> {/* Render BoxWithContent, it will use context */}
    </BoxProvider>
  );
}
